import { useEffect, useState } from 'react';
import { VersionCheckInteractor, versionCheckInteractor } from './versionCheck';

/**
 * Subscribes to the version checker and wires the browser-level triggers
 * (tab becomes visible, window focus). Mount once at the app level; the
 * tree-load trigger fires separately from TreeInteractorProvider.
 */
export function useVersionCheck(
  interactor: VersionCheckInteractor = versionCheckInteractor,
): boolean {
  const [isStale, setIsStale] = useState(interactor.isStale);

  useEffect(() => {
    setIsStale(interactor.isStale);
    const unsubscribe = interactor.subscribe(setIsStale);

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        void interactor.check();
      }
    };
    const onFocus = () => {
      void interactor.check();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('focus', onFocus);
    return () => {
      unsubscribe();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('focus', onFocus);
    };
  }, [interactor]);

  return isStale;
}
